import { SyntheticEvent } from "react";
import { Tab, Tabs } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import A11yProps from "components/navigation/a11yProps";
import { ActivityFormSection } from "../utils/activityFormConfig";

type ActivityFormTabsProps = {
  sections: ActivityFormSection[];
  value: number;
  onChange: (event: SyntheticEvent, value: number) => void;
  tabSx: SxProps<Theme>;
};

const ActivityFormTabs = ({ sections, value, onChange, tabSx }: ActivityFormTabsProps) => (
  <Tabs value={value} onChange={onChange} variant="scrollable">
    {sections.map((section, index) => (
      <Tab
        key={section.id}
        label={section.label}
        {...A11yProps(index)}
        sx={tabSx}
        disabled={section.disabled}
      />
    ))}
  </Tabs>
);

export default ActivityFormTabs;
